import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { QuickInsightsService } from 'src/app/shared/services/quick-insights/quick-insights.service';
import * as _ from 'lodash';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RatersService } from 'src/app/shared/services/raters/raters.service';
import { Subject } from 'rxjs';
import { NgIf } from '@angular/common';
import { ScoreTableComponent } from '../../../../shared/components/score/score-table/score-table.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-project-score-quick-insights-cohorts',
    templateUrl: './project-score-quick-insights-cohorts.component.html',
    styleUrl: './project-score-quick-insights-cohorts.component.scss',
    imports: [
        NgIf,
        ScoreTableComponent,
        LtmsLoaderComponent,
    ]
})
export class ProjectScoreQuickInsightsCohortsComponent implements OnInit {
  @Input('levelChanged') levelChanged!: Subject<any>;
  destroyRef = inject(DestroyRef);
  @Input() activeTab = '';
  @Input() selectedLevel: any = {};
  @Input() defaultLevelNameForPeers = '';
  @Input() config: any = {};
  @Input() public showComparisonFlag;
  @Output() exportCohortDataToDownloadCSV = new EventEmitter();
  raterType: any;
  cohorts = [];
  selectedCohort: any = {};
  columns: any = [];
  response = [];
  responseData: any;
  distribution = [];
  accessName = "";
  levelName = "";
  isDataAvailable = false;
  isLoading = true;
  selectedOption: any = {};
  transactionsMap: any = {};
  interactionsMap: any = {};
  isNPS = false;
  projectScore = null;

  size = 5;
  sortBy = 'desc';

  dateType = '';
  dateTypeChanged: boolean = false;
  accessChanged: boolean = false;
  hierarchyStackData: any = [];

  constructor(
    private _quickInsights: QuickInsightsService,
    private _helpers: HelpersService,
    private _raters: RatersService,
  ) {}

  ngOnInit(): void {
    this._helpers.appState.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response:any) => {
      if(response && !response.pending) {

        this.dateTypeChanged = false;
        this.accessChanged = false;
        // Check if date changed
        if(!_.isEmpty(this.dateType)) {
          if(this.dateType !== response.datePicker.trendType) {
            this.dateType = response.datePicker.trendType;
            this.dateTypeChanged = true;
          }
        }else {
          this.dateType = response.datePicker.trendType;
        }
        // Check if user access (hierarchy stack) changed
        if(!_.isEmpty(this.hierarchyStackData)) {
          if(this._helpers.generateHashForHierarchyStack(response.hierarchyStack) !== this._helpers.generateHashForHierarchyStack(this.hierarchyStackData)) {
            this.levelName = '';
            this.hierarchyStackData = response.hierarchyStack;
            this.accessChanged = true;
            this.dateTypeChanged = false;
          }
        }else {
          this.hierarchyStackData = response.hierarchyStack;
        } 
        this.initializeComponent();
      }
    });
  }
  ngOnChanges() {
    if(!this.dateTypeChanged && this.selectedLevel) {
      this.selectedOption = this.selectedLevel;
      if(this.selectedLevel.category == 'Peers') {
        var access = Helpers.getHierarchyStack();
        this.levelName = this.getLevelName(access[0]);
      }else {
        this.levelName = this.getLevelName(this.selectedOption);
      }
    }
    // onChange event triggered
    this.levelChanged.subscribe(obj => {
      if(obj && obj.level && obj.level) {
        
        this.dateTypeChanged = false; // reset retained flag for date changed
        this.accessChanged = false; // reset retained flag for hierarchy/user access changed

        this.selectedOption = obj.level;
        if(obj.level.category == 'Peers') {
          this.levelName = this.defaultLevelNameForPeers;
        }else {
          this.levelName = this.getLevelName(this.selectedOption)
        }
        this.exportData()
      }
    });
  }
  getLevelName(option: any) {
    let name = '';
    var levelMap = this._quickInsights.getHierarchyLevelList();
    if (levelMap && levelMap[option.field_id]) {
      name = levelMap[option.field_id].name;
    }
    return name;
  }
  initializeComponent() {
    this.isDataAvailable = false;
    this.isLoading = true;
    var access = Helpers.getHierarchyStack();
    if (access && access.length && access[0].group_key[0]) {
      this.accessName = (Helpers.groupKeyMapping && !_.isEmpty(Helpers.groupKeyMapping)&& Helpers.groupKeyMapping[access[0].group_key[0]])?Helpers.groupKeyMapping[access[0].group_key[0]]:access[0].group_key[0];
      if(!this.dateTypeChanged) {
        this.levelName = this.getLevelName(access[0]);
      }
    } else {
        this.accessName = Helpers.brandDetails.name;
    }
    // Get cohorts from Brand/Account object
    this.cohorts = this.getCohorts();
    this.selectedCohort = {};
    this.raterType = Helpers.brandDetails.main_rater_type;
    this.distribution = this._raters.getRaterDetails(this.raterType).distributions;
    if (this.raterType == 3) {
      this.isNPS = true;
    } else {
        this.isNPS = false;
    }
    if (this.config && this.config.sortBy) {
        this.sortBy = this.config.sortBy;
    }
    if (this.config && this.config.size) {
        this.size = this.config.size;
    }
    if (this.cohorts && this.cohorts.length) {
      // Set first cohort of list to selected cohort
      this.selectedCohort = this.cohorts[0];
      this.getOverallData();
    } else {
        this.isDataAvailable = false;
        this.isLoading = false;
    }
  }
  getCohorts() {
    var cohorts:any = [];
    var transactions = [];
    var interactions = [];

    var brandDetails = _.get(Helpers, "brandDetails")
    this.transactionsMap = {};
    this.interactionsMap = {};

    if (brandDetails.field_definitions && brandDetails.field_definitions.length) {
      _.each(brandDetails.field_definitions, (tagField) => {
          this.transactionsMap[tagField.field_id] = tagField;
      })
    }

    if (brandDetails.detailed_feedback_items && brandDetails.detailed_feedback_items.length) {
        _.each(brandDetails.detailed_feedback_items, (question) => {
            this.interactionsMap[question.field_id] = question;
        })
    }

    if (Helpers.hasProperty(brandDetails,'leaderboard_computation_config.transactions')) {
        transactions = brandDetails.leaderboard_computation_config.transactions;
    }

    if (Helpers.hasProperty(brandDetails,'leaderboard_computation_config.interactions')) {
        interactions = brandDetails.leaderboard_computation_config.interactions;
    }

    // If cohorts are available then process
    if (transactions && transactions.length) {
      for (var index in transactions) {
          var cohort: any = transactions[index];
          // The cohort can be compare filter or response type
          if (cohort.is_display && this.transactionsMap[cohort.field_id]) {
              cohort = _.extend(cohort, this.transactionsMap[cohort.field_id])
              cohort.field_type = "transaction";
              cohorts.push(cohort);
          }
      }
    }

    // If cohorts are available then process
    if (interactions && interactions.length) {
      for (var index in interactions) {
          var question: any = interactions[index];
          // The cohort can be compare filter or response type
          if (question.is_display && this.interactionsMap[question.field_id]) {
              question = _.extend(question, this.interactionsMap[question.field_id])
              question.display_name = question.question;
              question.name = question.text;
              question.field_type = "interaction";
              cohorts.push(question);
          }
      }
    }
    // Sort available cohorts by-name
    cohorts = _.sortBy(cohorts, 'name')
    return cohorts;
  }

  getOverallData() {
    this.isDataAvailable = false;
    this.isLoading = true;
    this.projectScore = null;
    this.response = [];
    var params: any = this._helpers.getInitialQueryParameters();
    params.from = _.get(Helpers, "datePicker.startDate");
    params.to = _.get(Helpers, "datePicker.endDate");
    params.view_type = 'overall';
    params.field_id = 'overall';
    params.field_type = 'overall';
    params.question_aggs = false;
    params.is_custom_date_range_selected = true;

    this._quickInsights.getComparisonV2Data(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(response => {
      if (response && response.data && response.data.code == 0 && response.data.feed_details && response.data.feed_details.current) {
        response = response.data.feed_details
        response = this._quickInsights.processResponse(response, this.raterType);
        // If Data contains some record then process
        if(response.current) {
          if (this.isNPS) {
            this.projectScore = response.current.net_promoter_score;
          } else {
            this.projectScore = response.current.average_rating;
          }
        }
        if (this.projectScore != null) {
            this.getTagDataForProject();
        } else {
            this.isDataAvailable = false;
            this.isLoading = false;
        }
      }
      else {
        this.isDataAvailable = false;
        // this.isDataLoaded = true;
      }
    })
  }

  getTagDataForProject() {
    this.response = [];
    this.responseData = {};
    var params: any = {};
    params.brand_id = Helpers.brandDetails._id;
    var access = Helpers.getHierarchyStack();
    if (access && access.length && access[0].group_key[0]) {
        params.hierarchy_level = access[0].field_id;
        params.hierarchy_value = access[0].group_key[0];
    }
    params.from = _.get(Helpers, "datePicker.startDate");
    params.to = _.get(Helpers, "datePicker.endDate");
    params.field_id = this.selectedCohort.field_id;
    params.field_type = this.selectedCohort.field_type;
    params.is_custom_date_range_selected = false;
    params.limit = 100;

    this._quickInsights.getLeaderboardSummary(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(response => {
      if (response && response.data && response.data.code == 0 && response.data.summary) {
        response = response.data.summary;
        if (Object.keys(response).length) {
          this.responseData = response;
          this.exportData()
        } else {
          this.isDataAvailable = false;
        }
      } else {
        this.isDataAvailable = false;
      }
      this.isLoading = false;
    })
  }
  // Present data in table
  exportData() {
    let response = this.responseData;
    this.getColumns();
    var topPerformerLevel = this.getTopPerformerLevel();
    // Parse response based on selected rater type and selected question
    response = this._quickInsights.processResponse(response, Helpers.brandDetails.main_rater_type, topPerformerLevel);
    // Set id and name in response to send into data
    for (var idx in response) {
      response[idx].id = idx;
      response[idx].name = idx;
      // Compute Impact of each
      if (this.isNPS) {
          response[idx].impact = (response[idx].net_promoter_score - this.projectScore!) * response[idx].number_of_users_rated_primary_rating;
      } else {
          response[idx].impact = (response[idx].average_rating - this.projectScore!) * response[idx].number_of_users_rated_primary_rating;
      }
    }
    // Sort response by number of records
    response = _.sortBy(response, 'impact');
    if (this.sortBy != 'asc') {
        // Sort them into descending order
        response = response.reverse();
    }
    // Take only 5 data from response
    response = response.splice(0, this.size);
    response = _.sortBy(response, 'net_promoter_score', this.sortBy).reverse();
    var columnsObj = Helpers.getColumnsWithDeviation(this.columns, response);
    this.columns = columnsObj.columns;
    // Hold response 
    this.response = response;
    this.exportCohortDataToDownloadCSV.emit({'column': this.columns, 'response' :this.response, 'cohort': this.selectedCohort?.name});
    this.isDataAvailable = true;
  }

  //Data table header config object
  getColumns() {
    // var isDeviationEnabled = $rootScope.showDeviation;
    var isDeviationEnabled = true;
    var name: any = {
        uniqueId: "name",
        header: "Name",
        csv_header: "Name",
        field_name: "name",
        display_name: "Name",
        order: "1",
        width: "120px",
        type: 'text',
        is_custom_style: true,
        dont_allow_sort: true,
        columnId: "id_quickInsights"
    };

    var scoreLabel = this.isNPS ? Helpers.getDisplayLabel('NPS') : Helpers.getDisplayLabel('Rating');

    var score = {
        uniqueId: this.isNPS ? 'net_promoter_score' : 'average_rating',
        header: "My " + scoreLabel,
        csv_header: "My " + scoreLabel,
        field_name: this.isNPS ? 'net_promoter_score' : 'average_rating',
        display_name: "My " + scoreLabel,
        type: 'number',
        is_deviation_enabled: isDeviationEnabled,
        width: "120px",
        order: "2",
        is_sorted: true,
        is_active: true,
        sort_order: 'desc',
        dont_allow_sort: true,
        style: { header: 'flex-end', row: 'flex-end', font: 'var(--lato-regular)' },
        columnId: "id_quickInsights"
    }
    var responseColumn = {
        uniqueId: "number_of_users_rated_primary_rating",
        header: "My Responses",
        csv_header: "My Responses",
        field_name: "number_of_users_rated_primary_rating",
        display_name: "My Responses",
        type: 'number',
        is_deviation_enabled: isDeviationEnabled,
        width: "120px",
        order: "3",
        dont_allow_sort: true,
        style: { header: 'flex-end', row: 'flex-end', font: 'var(--lato-regular)' },
        columnId: "id_quickInsights"
    };

    var topScore = {
        uniqueId: this.isNPS ? 'top_performer_nps' : 'top_performer_avg',
        header: "Top " + scoreLabel,
        csv_header: "Top " + scoreLabel,
        field_name: this.isNPS ? 'top_performer_nps' : 'top_performer_avg',
        display_name: "Top " + scoreLabel,
        type: 'number',
        is_deviation_enabled: false,
        width: "120px",
        order: "5",
        dont_allow_sort: true,
        style: { header: 'flex-end', row: 'flex-end', font: 'var(--lato-regular)' },
        columnId: "id_quickInsights"
    }

    var topBranch = {
        uniqueId: "top_performer_name",
        header: "Top " + this.levelName,
        csv_header: "Top " + this.levelName,
        field_name: "top_performer_name",
        display_name: "Top " + this.levelName,
        order: "4",
        width: "120px",
        type: 'text',
        dont_allow_sort: true,
        columnId: "id_quickInsights"
    };

    var promotersDistColumn = {
      uniqueId: "promoters_per",
      csv_header: "Promoters",
      field_name: "promoters_per",
      image: "assets/images/promoters.svg",
      type: 'component',
      dont_allow_sort: true,
      customClass: "toggle-table-column",
      width: "70px",
      order: "6",
      style: { font: 'var(--lato-regular)' },
      columnId: "id_quickInsights"
    };

    var passiveDistColumn = {
      uniqueId: "passives_per",
      csv_header: "Passives",
      field_name: "passives_per",
      image: "assets/images/passive.svg",
      type: 'component',
      dont_allow_sort: true,
      customClass: "toggle-table-column",
      width: "70px",
      order: "7",
      style: { font: 'var(--lato-regular)' },
      columnId: "id_quickInsights"
    };

    var detractorsDistColumn = {
      uniqueId: "detractors_per",
      csv_header: "Detractors",
      field_name: "detractors_per",
      image: "assets/images/detractors.svg",
      type: 'component',
      dont_allow_sort: true,
      customClass: "toggle-table-column",
      width: "70px",
      order: "8",
      style: { font: 'var(--lato-regular)' },
      columnId: "id_quickInsights"
    };

    // if (this.selectedCohort.drilldown && this.selectedCohort.drilldown.length) {
    //     name.is_clickable = true;
    //     name.listener = this.drillDown();
    // }

    this.columns = [];

    this.columns.push(name);
    this.columns.push(score);
    this.columns.push(responseColumn);
    this.columns.push(topBranch);
    this.columns.push(topScore);
    this.columns.push(promotersDistColumn);
    this.columns.push(passiveDistColumn);
    this.columns.push(detractorsDistColumn);
  }
  // drillDown() {

  // }
  getTopPerformerLevel() {
    let hierarchyLevel = this.selectedOption;
    if (hierarchyLevel) {
        if (hierarchyLevel.category == "Peers" && hierarchyLevel.value) {
            var levels = hierarchyLevel.value.split('_');
            levels[2] = parseInt(levels[2]) + 1;
            levels = levels.join('_');
            return levels
        } else {
            return hierarchyLevel.value;
        }
    }
    return null;
  }
}
